import { SelfTestAnswers } from "../../../../components/self-test/model/SelfTestAnswers";

export const result = (answers: SelfTestAnswers) => {
    const ans = Object.values(answers);

    const criteria1 = ans.filter(x => x === 'Yes').length > 7;
    const criteria2 = ans[13] === 'A';
    const criteria3 = ans[14] === 'C' || ans[14] === 'D';

    return { risk: criteria1 && criteria2 && criteria3 }
}